<template>
	<HeaderTab :title="plain_title" :swiper_tabs="swiper_tabs" :element="{ subtitle: amounts }">
		<template v-slot:title-content>
			<router-link v-if="supplier_id" :to="{ name: 'tiersTableauBord', params: { tiers_id: supplier_id } }">
				{{ supplier_name }}
			</router-link>
			<template v-else>{{ supplier_name }}</template>
			<template v-if="invoice_num"> - {{ invoice_num }}</template>
		</template>

		<template v-slot:title-tag>
			<b-badge v-if="lifecycle_code" :variant="lifecycle_variant" class="ml-2 align-self-center">
				{{ lifecycle_code }} - {{ lifecycle_label }}
			</b-badge>
		</template>
	</HeaderTab>
</template>


<script type="text/javascript">
	export default {
		name: "InvoiceSupplierFicheHeader",
		props: {
			invoice: { type: Object, default: null },
			swiper_tabs: { type: Array, default: () => [] }
		},

		data() {
			return {
				amounts: ''
			}
		},

		computed: {
			supplier_id() {
				return this.invoice && this.invoice.tier ? this.invoice.tier.tiers_id : null
			},

			supplier_name() {
				if(this.invoice && this.invoice.tier) {
					return this.invoice.tier.tiers_rs
				}

				return this.$t('invoice.supplier_fiche_title')
			},

			invoice_num() {
				return this.invoice ? this.invoice.suppliersocr_num : ''
			},

			lifecycle_code() {
				return this.invoice ? this.invoice.suppliersocr_lifecycle_code : null
			},

			/**
			 * Libellé du dernier statut de cycle de vie. Les codes sont réglementaires, leur
			 * traduction appartient au client : le serveur ne transmet que le code.
			 */
			lifecycle_label() {
				return this.lifecycle_code ? this.$t('invoice.supplier_lifecycle_status.' + this.lifecycle_code) : ''
			},

			/**
			 * Couleur du tag : un statut terminal ferme le cycle et mérite l'alerte, un litige ou une
			 * suspension appellent une action, une approbation rassure.
			 */
			lifecycle_variant() {
				if(this.invoice && this.invoice.suppliersocr_lifecycle_terminal) {
					return 'danger'
				}

				if(['205', '209', '212'].includes(this.lifecycle_code)) {
					return 'success'
				}

				if(['206', '207', '208'].includes(this.lifecycle_code)) {
					return 'warning'
				}

				return 'secondary'
			},

			/**
			 * Version texte du titre, pour le bandeau mobile : le titre enrichi du bandeau desktop
			 * porte un lien, que la prop title ne saurait transporter.
			 */
			plain_title() {
				return [this.supplier_name, this.invoice_num].filter(part => part).join(' - ')
			}
		},

		watch: {
			invoice: {
				handler: 'buildAmounts',
				immediate: true
			}
		},

		methods: {
			/**
			 * Montants du bandeau. Le formatage dépend de la devise, chargée de façon asynchrone : il
			 * ne peut donc pas vivre dans un computed, qui rendrait des promesses.
			 */
			async buildAmounts() {
				if(!this.invoice) {
					this.amounts = ''
					return
				}

				const currency = this.invoice.suppliersocr_currency || 'EUR'
				const ht = await this.priceFormat(this.invoice.suppliersocr_ht, currency, true)
				const ttc = await this.priceFormat(this.invoice.suppliersocr_ttc, currency, true)

				this.amounts = this.$t('invoice.suppliersocr_ht') + ' ' + ht + ' - ' + this.$t('invoice.suppliersocr_ttc') + ' ' + ttc
			}
		},

		components: {
			HeaderTab: () => import('@/components/HeaderTab')
		}
	}
</script>
